module.exports = __webpack_public_path__ + "static/media/Sort Z-a.b054d876.svg";